const aValidator = (value) => {
  if (!value) return "validate.a_empty";
  const regex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
  if (!regex.test(value)) return "validate.a_failed";
  return value.split(".").every((part) => Number(part) <= 255)
    ? true
    : "validate.a_range_failed";
};

export { aValidator };
